import {GeneralInfoModalProps} from "../../types";
import {Modal, Spin} from "antd";
import {useMemo} from "react";
import GeneralInfoForm from "./components/generalInfo-form/GeneralInfoForm";

const GeneralInfoModal = (props: GeneralInfoModalProps) => {
  const {generalInfoController} = props
  const {isLoading, isModalOpen, form, selectedGeneralInfoItem, toggleModal} = generalInfoController
  const title = useMemo(() => {

    return selectedGeneralInfoItem ? "Редагувати інформацію для громадян" : "Додати інформацію для громадян"

  }, [selectedGeneralInfoItem])


  return (<Modal width={700} style={{top: 20}} title={title} open={isModalOpen} onOk={() => {
    form.submit()
  }}
                 onCancel={toggleModal}
                 cancelButtonProps={{title: "Закрити"}} okButtonProps={{children: "Зберегти"}}>
    <Spin spinning={isLoading}>
      <GeneralInfoForm generalInfoController={generalInfoController}/>
    </Spin>
  </Modal>)
}

export default GeneralInfoModal